/* ==========================================================================
   BOUNTEOUS CONFIDENTIAL
   ___________________

   Copyright 2019 Bounteous
   All Rights Reserved.

   NOTICE:  All information contained herein is, and remains the property
   of Bounteous and its suppliers, if any. The intellectual and
   technical concepts contained herein are proprietary to Bounteous
   and its suppliers and are protected by trade secret or copyright law.
   Dissemination of this information or reproduction of this material
   is strictly forbidden unless prior written permission is obtained
   from Bounteous.
   ========================================================================== */

import { Component, registerComponent } from 'js/component.js';
const componentName = 'floating-button';

export class FloatingButton extends Component {

    /**
     * Get Button Width On Load
     * - clone the button element to get its width, then remove it from DOM
     */
    getButtonWidth = () => {
        const { parentNode } = this.element;
        const buttonClone = this.elements.contactButton.cloneNode(true);
        buttonClone.classList.add('hover');
        parentNode.appendChild(buttonClone);
        this.buttonWidth = buttonClone.offsetWidth;

        setTimeout(() => parentNode.removeChild(buttonClone), 1);
    };

    /**
     * Hide Contact Menu
     */
    closeContact() {
        this.elements.menuContainer.classList.add('hidden');
        this.elements.contactButton.classList.remove('hidden');
        this.elements.contactButton.style.width = '';
        this.elements.contactButton.setAttribute('aria-expanded', 'false');
        this.elements.menuContainer.setAttribute('aria-hidden', 'true');
        this.isOpen = false;
    }

    /**
     * Show Contact Menu
     */
    openContact() {
        this.elements.menuContainer.classList.remove('hidden');
        this.elements.contactButton.classList.add('hidden');
        this.elements.contactButton.setAttribute('aria-expanded', 'true');
        this.elements.menuContainer.setAttribute('aria-hidden', 'false');
        this.isOpen = true;
    }

    /**
     * Close Contact Button
     */
    unhoverContact = () => {
        if (!this.canHover) return;
        this.elements.contactButton.classList.remove('hover');
        this.elements.contactButton.style.width = '';
    };

    /**
     * On Button Click
     */
    onButtonClick = () => this.openContact();

    /**
     * On Header Click
     */
    onHeaderClick = () => this.closeContact();

    /**
     * On Outside Click
     */
    clickOutside = (e) => {
        if (!e.target.closest(`.${componentName}__links ul`)
            && !e.target.closest(`.${componentName}__contact-button`)
            && !e.target.closest(`.${componentName}__header`)
            && this.isOpen) this.closeContact();

        if(!e.target.closest(`.${componentName}__links ul`)
            && !e.target.closest(`.${componentName}__contact-button`)
            && !e.target.closest(`.${componentName}__header`)
            && this.elements.contactButton.classList.contains('hover')) {
            this.elements.contactButton.classList.remove('hover');
            this.elements.contactButton.style.width = '';
        }
    };

    /**
     * Add Event Listeners
     */
    addEventListeners() {
        // Global
        document.addEventListener('click', this.clickOutside);

        // Component
        this.elements.contactButton.addEventListener('click', this.onButtonClick);
        this.elements.contactButtonClose.addEventListener('click', this.onHeaderClick);
        this.elements.contactButton.addEventListener('mouseenter', () => {
            if (!this.canHover) return;
            this.elements.contactButton.classList.add('hover');
            this.elements.contactButton.style.width = `${this.buttonWidth}px`;
        });
        this.elements.contactButton.addEventListener('mouseleave', () => {
            clearTimeout(this.mouseLeaveTimerButton);
            this.mouseLeaveTimerButton = setTimeout(() => this.unhoverContact(), 500);
        });
        this.elements.menuContainer.addEventListener('mouseleave', () => {
            clearTimeout(this.mouseLeaveTimerMenu);
            this.mouseLeaveTimerMenu = setTimeout(() => this.closeContact(), 500);
        });
    }

    /**
     * Initialize Component
     */
    init() {
    // Set Up Elements
        this.elements = {
            container: this.element.querySelector(`.${componentName}__container`),
            contactButton: this.element.querySelector(`.${componentName}__contact-button`),
            contactButtonClose: this.element.querySelector(`.${componentName}__header`),
            menuContainer: this.element.querySelector(`.${componentName}__links`)
        };

        // Set Contact State
        this.isOpen = false;
        this.buttonWidth = 0;
        this.canHover = true;
        this.mouseLeaveTimerButton = null;
        this.mouseLeaveTimerMenu = null;

        // Fire Init Funcs
        if (!this.elements.container) return;
        this.addEventListeners();
        this.getButtonWidth();
    }
}

registerComponent(`.${componentName}`, FloatingButton);
